export default "__VITE_ASSET__Bz1DS6fq__"